import React, {
  startTransition,
  useContext,
  useEffect,
  useState,
  useSyncExternalStore,
} from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "wc-toast";
import { apiGet, apiPost } from "../utils/apiFetch";
import pathObj from "../utils/apiPath";
import { inRange, isEmpty, isNumber } from "lodash";
import AuthContext from "../context/AuthContext";
import obj from "../utils/constants";
import Multiselect from "multiselect-react-dropdown";

const PromotionalOffer = () => {
  const [data, setData] = useState([]);
  const [select, setSelect] = useState("");
  const [filter, setFilter] = useState({});
  const [percent, setPercent] = useState("");
  const [games, setGames] = useState([]);
  const [selectedGames, setSelectedGames] = useState([]);


  const getCount = async () => {
    const { data } = await apiGet(pathObj.notificationCount);
    if (data?.success) {
      setSelect(data?.results?.default_agentID);
      setPercent(data?.results?.defualtCommision);
    }
  };

  const getData = async (type) => {
    try {
      const { status, data: response_users } = await apiGet(
        pathObj.getpromotionalOffer,
        {
          type: type,
        }
      );
      if (status === 200) {
        if (response_users.success) {
          startTransition(() => {
            setData(response_users?.results);
            let obj1 = response_users?.results?.data;
            setFilter({
              ...obj1,
              fromPeriod: obj1?.promotal_start_date,
              toPeriod: obj1?.promotal_end_date,
              checked: obj1?.onOff,
              discount: obj1?.promotalDiscount,
              turnover: obj1?.turnover || 0,
              gameSlot: obj1?.gameSlot || 0,
            });
            if (!isEmpty(response_users?.results?.data)) {
              setPercent(response_users?.results?.data?.amount);
            }

            if(obj1?.gameSlot){
              const selectedOption = obj1?.gameSlot.split(",");
              const selectedOptionArray = obj?.gameSlot?.filter(game => selectedOption.includes(game.casinoType)) || [];
               setSelectedGames(selectedOptionArray)
            }

            
          });
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const check = () => {
    if (select == "First_deposit_bonus" || select == "Altime_deposit_bonus" ||  select == "weekly_loss_bonus"||  select == "daily_loss_bonus"||  select == "monthly_loss_bonus") {
      if (percent == 0 || isEmpty(percent)) {
        toast.error("Please enter amount greater than 0 ");
        return false;
      } else if (isEmpty(select)) {
        toast.error("Please select Offer");
        return false;
      } 

      // else if (!inRange(filter?.discount, 0, 100)) {
      //   toast.error("Discount should not be greater than 100");
      //   return false;
      // }
      else {
        return true;
      }
    } else if (
      select == "user_referral_bouns" 
    ) {
      if (isEmpty(select)) {
        toast.error("Please select Offer");
        return false;
      }else if(isEmpty(filter?.duration)){
        toast.error("Please select duration");
           return false;
        }
      // } else if (isEmpty(filter?.fromPeriod)) {
      //   toast.error("Please select from period");
      //   return false;
      // } else if (isEmpty(filter?.toPeriod)) {
      //   toast.error("Please select to period");
      //   return false;
      // }
      // else if (isEmpty(filter?.bonus)) {
      //   toast.error("Please select bonus");
      //   return false;
      // }
      else {
        return true;
      }
    }
  };
  const onSelectedData = (selectedList, selectedItem) => {
    console.log(selectedList, selectedItem);

    setGames((prev) => {
      return selectedList.map(item => item.casinoType).join()
      
    });
    
  };
  // console.log("------>",games);
  const submit = async () => {
    let isValid = check();
    if (isValid) {
      let firstSecond = {
        type: select,
        amount: percent,
        maxWin:filter?.maxWin,
        spin:filter?.spin,
        onOff: filter?.checked,
      };
      let refralBouns = {
        type: select,
        amount: filter?.amount,
        onOff: filter?.checked,
        bonus: filter?.bonus,
        duration: filter?.duration,
      };
      
      let arr = {
        Altime_deposit_bonus: firstSecond,
        user_referral_bouns: refralBouns,
        weekly_loss_bonus: firstSecond,
        daily_loss_bonus: firstSecond,
        monthly_loss_bonus: firstSecond,
       
      };
      try {
        const { status, data: response_users } = await apiPost(
          pathObj.promotionalOffer,
          arr[select]
        );
        if (status === 200) {
          if (response_users.success) {
            toast.success(response_users.message);
            setFilter({ fromPeriod: "", toPeriod: "", checked: false });
            setSelect("");
            setPercent("");
          }
        }
      } catch (error) {
        toast.error(error.message);
      }
    }
  };
  
 
  return (
    <div>
      <section className="set-limit-sec py-4">
        <Container fluid>
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="d-flex align-items-center mb-3  find-member-sec ">
                <Form.Label className="pe-2 mb-0 w-75">
                  Promotional Offer
                </Form.Label>
                <Form.Select
                  value={select}
                  onChange={(e) => {
                    getData(e.target.value);
                    setSelect(e.target.value);
                    setFilter({ fromPeriod: "", toPeriod: "", checked: false });
                  }}
                  aria-label="Default select example w-auto"
                >
                  <option value="">Select Offer</option>
                  {/* <option value="First_deposit_bonus">
                    First deposit bonus
                  </option> */}
                  <option value="Altime_deposit_bonus">
                    On deposit bonus
                  </option>
                  <option value="user_referral_bouns">
                    User Referral Bouns
                  </option>
                  <option value="weekly_loss_bonus">Weekly loss bonus</option>
                  <option value="daily_loss_bonus">Daily loss bonus</option>
                  <option value="monthly_loss_bonus">Monthly loss bonus</option>
                  {/* <option value="slot_game_bonus">Slot Game Bonus</option>
                  <option value="special_date_bonus">Special Date Bonus</option> */}
                </Form.Select>
              </Form.Group>
            </Col>
           
          
            {!isEmpty(select) && select == "user_referral_bouns" ? (
                <>
                  <Col md={3}>
                    <Form.Group className="d-flex align-items-center mb-3 find-member-sec">
                      <Form.Label className="pe-2 mb-0 w-50">
                        {select == "user_referral_bouns"
                          ? "Min Loss Amount"
                          : "Min Loss Amount"}
                      </Form.Label>
                      <Form.Control
                        value={filter?.amount}
                        placeholder="Enter min loss  amount"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            amount: e.target.value,
                          })
                        }
                        aria-label="Default select example w-auto"
                        type="number"
                        min="0"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="d-flex align-items-center mb-3 find-member-sec">
                      <Form.Label className="pe-2 mb-0 w-50">
                        {select == "user_referral_bouns"
                          ? "Referral Bonus %"
                          : "Loss Bonus %"}
                      </Form.Label>
                      <Form.Control
                        value={filter?.bonus}
                        placeholder="Enter Bonus"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            bonus: e.target.value,
                          })
                        }
                        aria-label="Default select example w-auto"
                        type="number"
                        min="0"
                      />
                    </Form.Group>
                  </Col>
                  {/* <Col md={3}>
                    <Form.Group className="d-flex align-items-center mb-3  find-member-sec">
                      <Form.Label className="pe-2 mb-0 w-50">
                        Turnover(%)
                      </Form.Label>
                      <Form.Control
                        value={filter?.turnover}
                        placeholder="Enter Turnover"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            turnover: e.target.value,
                          })
                        }
                        aria-label="Default select example w-auto"
                        type="number"
                        min="0"
                      />
                    </Form.Group>
                  </Col> */}
                     <Col md={3}>
              <Form.Group className="d-flex align-items-center mb-3  find-member-sec ">
                <Form.Label className="pe-2 mb-0 w-75">
                  Loss Duration
                </Form.Label>
                <Form.Select
                  value={filter?.duration}
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      duration: e.target.value,
                    })
                  }
                  aria-label="Default select example w-auto"
                >
                  <option value="">Select Duration</option>
                  <option value="weekly">
                    Weekly 
                  </option>
                  <option value="weekly">Daily </option>
                  <option value="monthly">Monthly  </option>
                 
                </Form.Select>
              </Form.Group>
            </Col>
                  <Col md={2}>
                  <Form.Group className="d-flex align-items-center mb-3 find-member-sec">
                    <Form.Label className="pe-2 mb-0 w-50">ON/OFF</Form.Label>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      checked={filter?.checked}
                      onClick={(e) => {
                        setFilter({ ...filter, checked: e.target.checked });
                      }}
                    />
                  </Form.Group>{" "}
                </Col>
                </>
              ):
              <>
              <Col md={3}>
                    <Form.Group className="d-flex align-items-center mb-3  find-member-sec">
                      <Form.Label className="pe-2 mb-0 w-50">
                        
                        {select == "Altime_deposit_bonus"
                          ? "Min Deposit Amount"
                          : "Min Loss Amount"}
                      </Form.Label>
                      <Form.Control
                        value={percent}
                        placeholder="Enter Min Deposit Amount"
                        onChange={(e) => setPercent(e.target.value)}
                        aria-label="Default select example w-auto"
                        type="number"
                        min="0"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="d-flex align-items-center mb-3  find-member-sec">
                      <Form.Label className="pe-2 mb-0 w-50">
                        Max Win Amount
                      </Form.Label>
                      <Form.Control
                        value={filter?.maxWin}
                        placeholder="Enter Win Amount"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            maxWin: e.target.value,
                          })
                        }
                        aria-label="Default select example w-auto"
                        type="number"
                        min="0"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="d-flex align-items-center mb-3  find-member-sec">
                      <Form.Label className="pe-2 mb-0 w-50">
                        Get Spin
                      </Form.Label>
                      <Form.Control
                        value={filter?.spin}
                        placeholder="Enter number of get spin"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            spin: e.target.value,
                          })
                        }
                        aria-label="Default select example w-auto"
                        type="number"
                        min="0"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                  <Form.Group className="d-flex align-items-center mb-3 find-member-sec">
                    <Form.Label className="pe-2 mb-0 w-50">ON/OFF</Form.Label>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      checked={filter?.checked}
                      onClick={(e) => {
                        setFilter({ ...filter, checked: e.target.checked });
                      }}
                    />
                  </Form.Group>{" "}
                </Col></>}
            
          
            <Col md={12}>
              <Button
                onClick={() => {
                  if (!isEmpty(select)) {
                    submit(select);
                  } else {
                    toast.error("Please select agent");
                  }
                }}
                className="btn btn-primary"
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default PromotionalOffer;

let count = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
];
